import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setToast } from "../../../app/appSlice";
import { useAppSelector } from "../../../hooks/hooks";
import { setForcedflowname } from "../editorSlice";

export const DeployementSettings = ({
  viewSettings,
  setViewSettings,
}: {
  viewSettings: boolean;
  setViewSettings: (value: boolean) => void;
}) => {
  const forcedFlowName = useAppSelector(
    (state) => state.editor.current?.forcedflowname
  );
  const dispatch = useDispatch();
  const [input, setInput] = useState<string | undefined>(forcedFlowName);
  const [checked, setChecked] = useState<boolean>(() => {
    if (forcedFlowName) return true;
    return false;
  });
  const regex = new RegExp("^[a-zA-Z0-9-]+$");

  useEffect(() => {
    if (!checked && forcedFlowName !== undefined) {
      setInput("");
    }
  }, [checked]);

  const regexChecker = input ? regex.test(input) : false;

  const saveIsDisable = !regexChecker && checked ? true : false;

  const footer = () => {
    return (
      <div className="flex justify-content-end mt-1">
        <Button
          label={"ANNULER"}
          type="button"
          onClick={() => {
            setViewSettings(false);
            setInput(forcedFlowName);
            setChecked(forcedFlowName ? true : false);
          }}
          className="m-2 p-button-outlined p-button-sm"
        />

        <Button
          label={"SAUVEGARDER"}
          type="button"
          disabled={saveIsDisable}
          onClick={() => {
            if (checked) {
              if (input) {
                if (regexChecker) {
                  dispatch(setForcedflowname(input));
                  setViewSettings(false);
                }
              } else
                dispatch(
                  setToast({
                    content: "Veuillez saisir un nom de flux personnalisé",
                    life: 5000,
                    severity: "error",
                    title: "Erreur",
                  })
                );
            } else {
              dispatch(setForcedflowname(""));
              setViewSettings(false);
            }
          }}
          className="m-2 p-button-sm"
        />
      </div>
    );
  };

  const header = () => {
    return (
      <div className="flex justify-content-between align-items-center">
        <div>Paramètrer un déploiement</div>
        <div>
          {input !== forcedFlowName && (
            <div
              className="mr-2"
              style={{
                backgroundColor: "#e9e9ff",
                color: "#696cff",
                padding: "5px",
                borderRadius: "5px",
              }}
            >
              Des changements n'ont pas été enregistrés !
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <Dialog
        visible={viewSettings}
        style={{ width: "35vw" }}
        onHide={() => setViewSettings(false)}
        footer={footer}
        header={header}
      >
        <b>
          Ce menu permet de définir le nom du flux qui sera lancé par le worker
          temporal. A n'utiliser que si vous savez exactement ce que vous
          faites.
        </b>

        {!checked ? (
          <div className="mt-3">Activer le Mode manuel :</div>
        ) : (
          <div className="mt-3">Désactiver le Mode manuel :</div>
        )}

        <InputSwitch checked={checked} onChange={(e) => setChecked(e.value)} />

        {checked ? (
          <div className="mt-2">
            <div>Nom personnalisé du flux :</div>
            <InputText
              value={input}
              className="mt-1"
              onChange={(e) => setInput(e.target.value)}
            />
            {!regexChecker && (
              <div className="error-text mt-1">
                Le nom personnalisé n'accepte que les caractères alphanumériques et le caractère ”-”
              </div>
            )}
          </div>
        ) : null}
      </Dialog>
    </>
  );
};
